
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

export const carousels = () => {
    let home = document.querySelector(".home");
    if(home){
        const swiper = new Swiper('.swiper-home', {
            loop: true,
            slidesPerView: 1.15,
            spaceBetween: 16,
            breakpoints: {
                // when window width is >= 600px
                600: {
                    slidesPerView: 1.8,
                },
                // when window width is >= 800px
                800: {
                    slidesPerView: 2.5,
                },
                // when window width is >= 1050px
                1050: {
                    slidesPerView: 2.75,
                },
                // when window width is >= 1280px
                1280: {
                    slidesPerView: 3.25,
                }
            },
    
        });
        const swiperElement = document.querySelector(".swiper-partners");
        const swiperWrapper = swiperElement.querySelector(".swiper-wrapper");
        const swiperSlides = swiperElement.querySelectorAll(".swiper-slide");
        swiperSlides.forEach((slide, _) => {
            const clonedSlide = slide.cloneNode(true);
            swiperWrapper.appendChild(clonedSlide);
        });
        const swiperPartners = new Swiper('.swiper-partners', {
            loop: true,
            slidesPerView: 3.7,
            spaceBetween: 44,
            breakpoints: {
                 // when window width is >= 1280px
                 576: {
                    slidesPerView: 4,
                },
                // when window width is >= 1280px
                768: {
                    slidesPerView: 5,
                },
                // when window width is >= 1280px
                1280: {
                    slidesPerView: 6,
                }
            },
    
        });
    }
   
}


